import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-select-filter',
    templateUrl: './select-filter.component.html',
    styleUrls: ['./select-filter.component.scss']
})
export class SelectFilterComponent implements OnInit, OnDestroy {
    @Input() field: string;
    @Input() placeholder: string;
    @Input() appendTo;
    @Input() options;

    value: string;
    unsubscribe$ = new Subject();

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        this.route.queryParamMap
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                this.value = params.get(this.field);
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async valueChanged() {
        const queryParams: any = {};
        queryParams[this.field] = this.value;
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge'
        });
    }
}
